// extracted by mini-css-extract-plugin
export default {"styled-checkbox":"Checkbox_styled-checkbox__-OIBX","align-checkbox":"Checkbox_align-checkbox__bBcUw"};